import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=176f6d51&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=js&"
export * from "./Alert.vue?vue&type=script&lang=js&"
import style0 from "./Alert.scss?vue&type=style&index=0&id=176f6d51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176f6d51",
  null
  
)

export default component.exports